module.exports = __webpack_public_path__ + "static/media/morion-bold.1f07cfc6.woff";